import React from 'react';
import {
  FlagProvider,
  LocalStorageProvider,
  UnleashClient,
} from '@unleash/proxy-client-react';
import {
  isPathBasedEmbeddedMode,
  unleashClientKey,
  unleashUrl,
} from '../constants/config';
import SessionStorageProvider from './sessionStorageProvider';

const unleashConfig = {
  url: unleashUrl ?? window.location.origin,
  clientKey: unleashClientKey || 'no-client-key',
  appName: 'elis-frontend',
  disableRefresh: false,
  disableMetrics: true,
  refreshInterval: 60 * 60 * 24,
  storageProvider: isPathBasedEmbeddedMode()
    ? new SessionStorageProvider()
    : new LocalStorageProvider(),
};

export const unleashClient = new UnleashClient(unleashConfig);

type Props = {
  children: React.ReactNode;
};

const UnleashProvider = ({ children }: Props) => {
  return (
    <FlagProvider
      unleashClient={unleashClient}
      startClient={!!unleashUrl && unleashConfig.clientKey !== 'no-client-key'}
    >
      {children}
    </FlagProvider>
  );
};

export default UnleashProvider;
